import { useState } from 'react';
import { CoachRequestTimesOverlay } from './CoachRequestTimes';
import { LessonEventCard } from './LessonEventCard';
import { TEXT_ACTION } from './surfaces';
import { useLiveCalls } from '../../hooks/useLiveCalls';
import { useViewerZone } from '../../hooks/useViewerZone';
import { firstNameOf } from '../../utils/liveLessonText';
import { movedLessonOf } from '../../utils/lessonTimes';
import type { Message } from '../../types/chat';

/**
 * "Ana moved the lesson to Fri, Oct 30 at 12:40 AM." in the thread (decision
 * 123; booking-contracts.md 11): the system line, and under it for the coach
 * only "Doesn't work? Suggest new times", which opens their Request a New
 * Time for that lesson (98). The line names no lesson, so it is the coach's
 * lesson the player moved at the line's moment (rescheduleHistory's
 * player_move), or the line's own bookingId when the server sends one.
 */
export function LessonMovedLine({ message }: { message: Message }) {
  const { upcoming } = useLiveCalls('coach');
  const tz = useViewerZone();
  const [suggesting, setSuggesting] = useState(false);
  const b = movedLessonOf(upcoming, message);
  const sheet = suggesting && b && (
    <CoachRequestTimesOverlay booking={b} tz={tz} playerFirst={firstNameOf(b.playerName, 'your player')} onClose={() => setSuggesting(false)} />
  );
  // With its lesson (from 30 Oct): the event card (decision 126), the coach's way on under it.
  if (message.bookingId) {
    return (
      <div data-lesson-moved>
        <LessonEventCard message={message}>
          {b && (
            <p className="mt-2 text-[13px] leading-[18px] text-db-text-2">
              Doesn&apos;t work?{' '}
              <button type="button" onClick={() => setSuggesting(true)} className={TEXT_ACTION} data-suggest-new-times>Suggest new times</button>
            </p>
          )}
        </LessonEventCard>
        {sheet}
      </div>
    );
  }
  return (
    <div className="my-4 flex justify-center" data-lesson-moved>
      <div className="max-w-md px-4 text-center text-[13px] leading-[18px] text-[rgba(60,60,67,0.6)]">
        {message.text}
        {b && (
          <span className="mt-1 block">
            Doesn&apos;t work?{' '}
            <button type="button" onClick={() => setSuggesting(true)} className={TEXT_ACTION} data-suggest-new-times>
              Suggest new times
            </button>
          </span>
        )}
      </div>
      {sheet}
    </div>
  );
}
